import { render, staticRenderFns } from "./ImportTradeIn.vue?vue&type=template&id=496cd920&scoped=true"
import script from "./ImportTradeIn.vue?vue&type=script&lang=js"
export * from "./ImportTradeIn.vue?vue&type=script&lang=js"
import style0 from "./ImportTradeIn.vue?vue&type=style&index=0&id=496cd920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496cd920",
  null
  
)

export default component.exports